import AWS from "aws-sdk"; // v2 SDK assumed

export async function chatWithAI(message, awsCreds) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  console.log(`Sending message to ${apiUrl}: ${message}`);

  const res = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      REACT_APP_API_KEY: apiKey,
      Origin: window.location.origin,
    },
    body: message,
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`API error: ${res.status} ${errorText}`);
  }

  const data = await res.json();
  console.log("Raw API response:", data);

  return data;
}
